

















import { computed, defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { isTipMessageDetails } from "@scrile/api-provider/dist/api/TipProvider";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "StreamMessage",
  components: { BaseAvatar, FormatMoney, BaseIcon },
  props: {
    message: { type: Object as () => Message, required: true },
  },
  setup(props) {
    const amount = computed<number>(() =>
      isTipMessageDetails(props.message.details) ? props.message.details.amount : 0
    );

    return {
      amount,
    };
  },
});
